import { useState } from "react";
import { Form, Button, Badge } from "react-bootstrap";
import "./index.css"

const EmailInput = ({ handleEmailsChange, emails, title = 'Correos' }) => {
  const [inputValue, setInputValue] = useState("");

  const isValidEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  const addEmail = (email) => {
    email = email.trim();
    if (email && isValidEmail(email) && !emails.includes(email)) {
      handleEmailsChange([...emails, email]);
    }
    setInputValue("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      addEmail(inputValue);
    }
  };

  const handleRemoveEmail = (emailToRemove) => {
    handleEmailsChange(emails.filter(email => email !== emailToRemove));
  };

  return (
    <div>
      <Form.Group>
        <Form.Label>{title}</Form.Label>
        <Form.Control
          type="text"
          placeholder="Escribe un correo y presiona Enter"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
        />
      </Form.Group>
      <div className="mt-2">
        {emails?.map((email, index) => (
          <Badge key={index} pill bg="primary" className="me-2 badge-class">
            {email}{" "}
            <Button
              variant="light"
              size="sm"
              onClick={() => handleRemoveEmail(email)}
              className="p-0 ms-1 btn-class"
            >
              <span>x</span>
            </Button>
          </Badge>
        ))}
      </div>
    </div>
  );
};

export default EmailInput;
